import { Component } from 'react';

import { getPropsOrDefault } from '../../common/utils.jsx';
import { resetFieldValue, setFieldValue } from '../app.reducer.jsx';
import { bindActionCreators } from '../app.store.jsx';

const UNKNOWN = 'UNKNOWN';

export default class FormComponent extends Component {
  constructor(props) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.isVisible = this.isVisible.bind(this);
    this._setFieldValue = bindActionCreators(setFieldValue);
    this._resetFieldValue = bindActionCreators(resetFieldValue);
  }

  onChangeHandler(eventOrValue) {
    const { name, value: propsValue, disabled } = this.props;
    if (disabled) {
      return;
    }
    const value = eventOrValue.target
      ? eventOrValue.target.value
      : eventOrValue;
    let { root, onChangeCallback } = this.props;
    root = root || getPropsOrDefault(this, 'props.props.root', undefined);

    if ('function' === typeof onChangeCallback) {
      onChangeCallback(name, value, root);
    } else if (UNKNOWN === propsValue && UNKNOWN === value) {
      this._resetFieldValue(name, root);
    } else {
      this._setFieldValue(name, value, root);
    }
  }

  isVisible() {
    const { condition, fieldValues } = this.props;

    let isVisible = true;

    if ('function' === typeof condition) {
      isVisible = condition(fieldValues);
    }
    return isVisible;
  }
}
